const SOURCE_SELECTOR = '[data-select-dependent-source]';

const TARGET_DATA_ATTRIBUTE = 'data-select-dependent-target';
const ACTIVE_ATTRIBUTE = 'data-select-dependent-active';
const TARGET_VALUE_ATTRIBUTE = 'data-select-dependent-value';

const hideAllDependentElements = dependentId => {
  const $dependentElements = $(`[${TARGET_DATA_ATTRIBUTE}="${dependentId}"]`);
  $dependentElements.removeAttr(ACTIVE_ATTRIBUTE);
  $dependentElements.find('input, textarea').attr('disabled', 'disabled');
};

const showSelectedElement = (select, dependentId, selectedValue) => {
  var $targetElement = null;
  if (select.closest(SOURCE_SELECTOR).data('select-dependent-match') == 'exact') {
    $targetElement = $(`[${TARGET_DATA_ATTRIBUTE}="${dependentId}"][${TARGET_VALUE_ATTRIBUTE}="${selectedValue}"]`);
  } else {
    $targetElement = $(`[${TARGET_DATA_ATTRIBUTE}="${dependentId}"][${TARGET_VALUE_ATTRIBUTE}*="${selectedValue}"]`);
  }
  $targetElement.attr(ACTIVE_ATTRIBUTE, true);
  $targetElement.find('input, textarea').attr('disabled', false);
};

class SelectDependent {
  constructor() {
    if ($(SOURCE_SELECTOR).size()) {

      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    $(SOURCE_SELECTOR)
      .on('change', 'select', this.updateTarget)
      .find('select')
      .trigger('change');
  }

  updateTarget(event) {
    const $select = $(event.currentTarget);
    const selectedValue = $select.val();
    const dependentId = $select.closest(SOURCE_SELECTOR).data('select-dependent-source');

    hideAllDependentElements(dependentId);
    showSelectedElement($select, dependentId, selectedValue);
  }
}

export default SelectDependent;



// WEBPACK FOOTER //
// ./src/javascripts/SelectDependent.js